
import { Context } from '@nuxt/types'
import { defineComponent } from 'vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import BlogAcfBlocks from "~/components/blog/BlogAcfBlocks.vue";

export default defineComponent({
  name: 'acquisition',
  components: {BlogAcfBlocks},
  extends: MachinationsLightPage,
  layout: 'machinations',
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    return {
      ...pageHead,
      meta: [
        ...pageHead?.meta,
      ],
    }
  },
  async asyncData(context: Context): Promise<void> {
    const { store } = context

    await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'acquisition',
    })

    await store.dispatch('common/setupPageLight', { context })
    await store.dispatch('wp/fetchTwitterCode', { context })
  },

})
